module.exports = __webpack_public_path__ + "static/media/4ODA7.a9c11dd2.jpg";